import React from 'react';
import { Shield, Microscope, Truck, HeadphonesIcon, Award, Leaf } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Shield,
      title: 'Quality Assurance',
      description: 'Every batch undergoes rigorous quality testing to ensure premium standards and nutritional consistency.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: Microscope,
      title: 'Scientific Formulation',
      description: 'Our products are developed using advanced nutritional science and veterinary expertise.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: Truck,
      title: 'Timely Delivery',
      description: 'Reliable supply chain ensures your feed requirements are met on time, every time.',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: HeadphonesIcon,
      title: '24/7 Support',
      description: 'Our expert team provides round-the-clock technical support and nutritional guidance.',
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: Award,
      title: 'Industry Recognition',
      description: 'Certified by leading agricultural bodies with multiple quality awards and recognitions.',
      color: 'from-yellow-500 to-yellow-600'
    },
    {
      icon: Leaf,
      title: 'Sustainable Practices',
      description: 'Environmentally responsible manufacturing with sustainable sourcing and eco-friendly processes.',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-800 mb-6">
            Why Choose Simran Industries?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Discover what makes us the preferred choice for thousands of dairy farmers 
            and livestock owners across India.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-200 hover:scale-105">
              <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${reason.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-200`}>
                <reason.icon className="text-white" size={28} />
              </div>
              
              <h3 className="text-xl font-bold text-amber-800 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="space-y-4">
              <div className="text-4xl font-bold text-amber-600">ISO 9001</div>
              <p className="text-gray-600">Quality Management Certified</p>
            </div>
            <div className="space-y-4">
              <div className="text-4xl font-bold text-green-600">FSSAI</div>
              <p className="text-gray-600">Food Safety Standards Approved</p>
            </div>
            <div className="space-y-4">
              <div className="text-4xl font-bold text-blue-600">BIS</div>
              <p className="text-gray-600">Bureau of Indian Standards</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;